import { AlertTriangle, LoaderCircle } from "lucide-react";

import { GameShell } from "./components/GameShell";
import { StartScreen } from "./components/StartScreen";
import { useCampaign } from "./lib/useCampaign";

const SUPPORTED_CONTRACT = {
  apiVersion: 1,
  rulesetVersion: 4,
  catalogRevision: 4,
  maximumStateSchemaVersion: 7,
} as const;

export default function App() {
  const campaign = useCampaign();

  if (!campaign.campaignId) {
    return <StartScreen busy={campaign.isBusy} error={campaign.error as Error | null} onStart={(name) => campaign.create({ name })} saves={campaign.saves} onOpen={campaign.activate} onRemove={campaign.forget} onRecover={campaign.recover} onRecoveryKey={campaign.recoveryKeyFor} onRotateRecoveryKey={campaign.rotateAccess} />;
  }
  if (campaign.isLoading && !campaign.payload) {
    return <main className="loading-screen"><div className="loading-mark"><LoaderCircle /><span /></div><h1>Opening the bunker</h1><p>Resolving what happened while you were away…</p></main>;
  }
  if (!campaign.payload) {
    return <main className="fatal-screen"><AlertTriangle /><h1>The bunker cannot be reached.</h1><p>{(campaign.error as Error | null)?.message ?? "The campaign save is unavailable."}</p><div className="fatal-actions"><button className="primary-button" onClick={() => void campaign.refetch()}>Try again</button><button className="secondary-button" onClick={campaign.reset}>Forget this save</button></div></main>;
  }
  const contract = campaign.payload.contract;
  if (
    contract &&
    (contract.api_version !== SUPPORTED_CONTRACT.apiVersion ||
      contract.ruleset_version !== SUPPORTED_CONTRACT.rulesetVersion ||
      contract.catalog_revision !== SUPPORTED_CONTRACT.catalogRevision ||
      contract.state_schema_version > SUPPORTED_CONTRACT.maximumStateSchemaVersion)
  ) {
    return <main className="fatal-screen"><AlertTriangle /><h1>This save needs a different game version.</h1><p>The server returned a campaign contract this client cannot safely simulate. The save has not been changed.</p><div className="fatal-actions"><button className="secondary-button" onClick={campaign.reset}>Choose another community</button></div></main>;
  }
  return <GameShell payload={campaign.payload} busy={campaign.isBusy} error={campaign.error as Error | null} report={campaign.latestReport} onCommand={campaign.command} onDecision={campaign.decideCrisis} onDismissReport={campaign.dismissReport} onReset={campaign.reset} />;
}
